import { render, staticRenderFns } from "./operate.vue?vue&type=template&id=9adbd654&scoped=true&"
var script = {}
import style0 from "./operate.vue?vue&type=style&index=0&id=9adbd654&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9adbd654",
  null
  
)

export default component.exports